// Autogenerated file
export const organizationRegistrationStatusesEnum = {
    OrganizationCreated: "OrganizationCreated",
    RelayCreated: "RelayCreated",
    RelayVerified: "RelayVerified",
    RelaySetupCompleted: "RelaySetupCompleted",
    DriversAdded: "DriversAdded",
    TrucksAdded: "TrucksAdded",
    Completed: "Completed",
};
export const organizationRegistrationStatuses = [
    { label: "Создана организация", value: "OrganizationCreated" },
    { label: "Создан ретранслятор", value: "RelayCreated" },
    { label: "Ретранслятор верифицирован", value: "RelayVerified" },
    { label: "Настройка ретранслятора завершена", value: "RelaySetupCompleted" },
    { label: "Водители добавлены", value: "DriversAdded" },
    { label: "Транспортные средства добавлены", value: "TrucksAdded" },
    { label: "Регистрация завершена", value: "Completed" },
];
